import { AuthLayout } from 'src/features/auth/components';
import { RegisterForm } from 'src/features/auth/components/RegisterForm';

const Register = () => {
    return (
        <AuthLayout>
            <RegisterForm />
        </AuthLayout>
    );
};

export { Register };
